import { makeStyles } from "@material-ui/core";
import { getDeviceType } from "~/helpers/deviceHelper";

const MuiStylesFooterContainer = makeStyles((theme) => ({
	footer: {
		width: " -webkit-fill-available",
		height: getDeviceType() === "mobile" ? "55px" : "35px",
		objectFit: "contain",
		borderTop: "1px solid #0000000d",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	nameContainer: {
		fontSize: 10,
		margin: "-4px -10px",
		// position: "absolute",
	},
	button: {
		width: "25%",
		display: "initial",
	},
	buttonWithCoupon: {
		width: "20%",
		display: "initial",
	},

	footerLoginAnonymous: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		cursor: "pointer",
		height: "3rem",
		backgroundColor: "#fff",
		boxShadow: "0 -1px 3px rgba(0, 0, 0, 0.05)"
	},

	footerAnonymousText: {
		fontSize: 16, 
		textDecoration: 'underline', 
		color: "rgba(0, 0, 0, 0.65)"
	}
}));

export default MuiStylesFooterContainer;
